export default "__VITE_ASSET__dDjhhr5c__"